import { ReactNode } from 'react';
import { useModal } from '@/hooks';
import { getPropertyProgress, resetPropertyStep, selectPropertyProgressIsLoading } from '../../feature';
import { useAppDispatch, useAppState } from '@/store';
import { Button } from '@/ui';
import { StepType } from '@/models/step.model';
import { useTranslation } from 'react-i18next';
import { getEntityId } from '@/utils';
import { StyledActions, StyledMessageModal } from './ResetAdStepButtonStyles';

type TResetStepButtonProps = {
  propertyId: string;
  icon?: ReactNode;
  stepName: StepType;
};

const ResetAdStepButton = ({ propertyId, stepName, icon }: TResetStepButtonProps) => {
  const { isOpened, openModal, closeModal } = useModal();
  const { t } = useTranslation(['property', 'common']);
  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectPropertyProgressIsLoading);

  const handleConfirm = async (clearData?: boolean) => {
    try {
      await dispatch(resetPropertyStep({ propertyId: getEntityId(propertyId), stepName, clearData })).unwrap();
      await dispatch(getPropertyProgress({ propertyId: getEntityId(propertyId) })).unwrap();
      closeModal();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Button type="default" shape="round" onClick={openModal} icon={icon}>
        {t('button_reset_step')}
      </Button>
      <StyledMessageModal
        open={isOpened}
        onCancel={closeModal}
        destroyOnClose
        title={t('button_reset_step')}
        okText
        footer={
          <StyledActions>
            <Button block shape="round" onClick={closeModal}>
              {t('action_cancel', { ns: 'common' })}
            </Button>
            <Button block shape="round" type="primary" loading={isLoading} onClick={() => handleConfirm()}>
              {t('button_reset_step_keep_data')}
            </Button>
            <Button block shape="round" type="primary" loading={isLoading} onClick={() => handleConfirm(true)}>
              {t('button_reset_step_clear_data')}
            </Button>
          </StyledActions>
        }
        styles={{
          mask: { background: 'rgba(0, 0, 0, 0.78)' },
        }}
      >
        {t('reset_confirmation_message')}
      </StyledMessageModal>
    </>
  );
};

export default ResetAdStepButton;
